import config from "../config/config-server";

const loginUser = async (email, password) => {
    const API_LOGIN = `${config.apiUrl}/api/login`;
    const dataUser = {
        email,
        password
    }

    const data = await fetch(API_LOGIN, {
        method: 'POST',
        body: JSON.stringify(dataUser),
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((res) => {
            return res.json();
        })
        .catch(err => {
            console.log(err)
        })
        return data;
}

export default loginUser;